
import { DateTime } from 'luxon';
import { defineComponent } from 'vue';
import { isNullOrUndefined, isToday, isTomorrow } from '@/shared/helpers';
import { mapActions, mapGetters } from 'vuex';
import { ActionTypes } from '@/store/actionTypes';
import SomethingWrongOverlay from '@/components/SomethingWrongOverlay.vue';

export default defineComponent({
    components: {
        SomethingWrongOverlay,
    },
    props: {
        driverCode: {
            type: String,
            required: true,
        },
        companyId: {
            type: String,
            required: true,
        },
    },
    created() {
        const driverInfo = {
            driverCode: this.driverCode,
            company: this.companyId,
        };

        this.fetchDriver(driverInfo).then(this.fetchActiveLoad);
    },
    methods: {
        ...mapActions({
            fetchActiveLoad: ActionTypes.FETCH_ACTIVE_LOAD,
            fetchDriver: ActionTypes.FETCH_DRIVER,
        }),
        handleYesClick() {
            this.$router.push({
                name: 'UpdatePTA',
                query: { mode: 'return_home' },
            });
        },
        handleNoClick() {
            this.$router.push({ name: 'UpdatePTA' });
        },
    },
    computed: {
        ...mapGetters({
            driver: 'getDriver',
            activeLoad: 'getActiveLoad',
            commitError: 'getError',
        }),
        showSystemPta() {
            const isFuturePta =
                !isNullOrUndefined(this.driver.pta) &&
                this.driver.pta > DateTime.now();
            const isAfterActiveLoadArrivalTime =
                !this.activeLoad ||
                this.driver.pta >
                    this.activeLoad.destination.earliestArrivalTime;

            return isFuturePta && isAfterActiveLoadArrivalTime;
        },
        todayOrTomorrowText() {
            const driver = this.driver;

            if (isToday(driver?.pta)) {
                return 'Today';
            }

            if (isTomorrow(driver?.pta)) {
                return 'Tomorrow';
            }

            return '';
        },
        dateText() {
            const driver = this.driver;

            return driver && driver.pta.toFormat('EEEE, MMMM d');
        },
        timeText() {
            const driver = this.driver;

            return driver && driver.pta.toFormat('h:mm a');
        },
    },
    watch: {
        activeLoad() {
            if (
                !this.driver?.pta ||
                !this.activeLoad?.destination?.earliestArrivalTime
            ) {
                return;
            }

            const { earliestArrivalTime } = this.activeLoad.destination;
            const driverPtaIsPast = this.driver.pta <= DateTime.now();
            const driverPtaIsAfterEarliestDelivery =
                this.driver.pta <= earliestArrivalTime;

            if (driverPtaIsPast || driverPtaIsAfterEarliestDelivery) {
                this.$router.push({ name: 'UpdatePTA' });
            }
        },
    },
});
